import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { TOOLS_PANEL_EASE, TOOLS_PANEL_TRANSITION_MS } from './tools-panel-motion';

interface ToolsPanelContentTransitionProps {
  panelKey: string;
  children: React.ReactNode;
}

/** מעטפת תוכן פאנל — `initial={false}` כדי שהתוכן לא יישאר שקוף עד רימאונט (Drawer + layout). */
const ToolsPanelContentTransition: React.FC<ToolsPanelContentTransitionProps> = ({ panelKey, children }) => {
  const reduceMotion = useReducedMotion();

  /** initial={false} — מניעת מצב שבו opacity נשאר 0 עד אינטראקציה (רימאונט), כשההורה בתוך Drawer עדיין מסדר layout */
  return (
    <motion.div
      key={panelKey}
      initial={false}
      animate={reduceMotion ? { opacity: 1 } : { opacity: 1, x: 0 }}
      transition={{
        duration: TOOLS_PANEL_TRANSITION_MS / 1000,
        ease: TOOLS_PANEL_EASE,
        opacity: { duration: TOOLS_PANEL_TRANSITION_MS / 1000 },
      }}
      style={{
        width: '100%',
        height: '100%',
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 auto',
      }}
    >
      {children}
    </motion.div>
  );
};

export default React.memo(ToolsPanelContentTransition);
